VjsAdmin.DistrictLessons = (function () {
    const init = function () {
        // go through each already selected package
        // and add the inferred and inferred-{package_id} classes
        $('#district-packages input:checked').each(function () {
            const packageId = $(this).data('package-id');
            const lessonIds = $(this).data('lesson-ids').split(',');

            $.each(lessonIds, (index, lessonId) => {
                const lessonCheckbox = $(`#district-lessons input:checkbox[data-lesson-id=${lessonId}]`);
                lessonCheckbox.addClass('inferred');
                lessonCheckbox.addClass(`inferred-${packageId}`);
            });
        });

        // when a package is checked or unchecked...
        // check or uncheck the related lessons
        $('#district-packages').on('change', 'input:radio', function () {
            const packageId = $(this).data('package-id');
            const lessonIds = $(this).data('lesson-ids').split(',');

            // this will just remove all the inferred package ids and reset the lessons before re-adding when selecting a package
            $('#district-lessons input:checkbox')
                .prop('checked', false)
                .removeClass('inferred-1')
                .removeClass('inferred-2')
                .removeClass('inferred-3');
            $.each(lessonIds, (index, lessonId) => {
                const lessonCheckbox = $(`#district-lessons input:checkbox[data-lesson-id=${lessonId}]`);
                lessonCheckbox.addClass('inferred').addClass(`inferred-${packageId}`).prop('checked', true);
            });
        });
    };

    return {
        init,
    };
}());
